import { Outlet } from 'react-router-dom'
import Footer from '../components/Footer/FooterSection'
import HeaderTwo from '../components/HeaderTwo/HeaderTwoSection'
import '../styles/account.scss'
import CustomHistory from '../components/customHistory/CustomHistorySection'
import AccountSidenav from '../components/AccountSidenav/AccountSidenav'
import {  ChevronRight, LayoutGrid } from 'lucide-react'
import { useState } from 'react'
import { motion } from 'framer-motion'


const Account = () => {

    const [toggleMobile, setToggleMobile] = useState(false)

    const handleToggle = () => {
        setToggleMobile((prev) => !prev)
    }

    return (<div className="acct">
        <HeaderTwo></HeaderTwo>
        <CustomHistory></CustomHistory>
        <div className='content'>

            <div className='accGrid'>
                <AccountSidenav toggle={toggleMobile} setToggle={setToggleMobile}></AccountSidenav>

                <div className='accountMenu' onClick={handleToggle}>
                    <LayoutGrid size={23}></LayoutGrid>
                    <div className='title'>Menu</div>

                    <motion.div
                        className="arr"
                        animate={{ scaleX: toggleMobile ? -1 : 1 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                        <ChevronRight className='arr' size={18} />
                    </motion.div>

                </div>

                <Outlet></Outlet>
            </div>

        </div>
        <Footer></Footer>
    </div>)
}

export default Account;